import { Button } from '../../../../components/Button/Button'
import styles from './DrillControls.module.scss'
import {
  useActiveFormattedDrill,
  useDrills,
  useSelectedFormattedDrill
} from '../../hooks'
import { useAppDispatch } from '../../../../store/hooks'
import { startDrill, stopDrill, updateExistingDrill } from '../../thunks'
import { useSelectedFormattedSession } from '../../../sessions/hooks'
import { useEffect, useState } from 'react'
import BasicSelect from '../../../../components/Material/Select'
import { selectDrill } from '../../slice'
import { endTimeEvent } from '../../../events/actions'
import { useTimeEvents } from '../../../events/time/hooks'

export const DrillControls = () => {
  const dispatch = useAppDispatch()

  const { drillCount } = useDrills()

  const formattedSession = useSelectedFormattedSession()
  const { live } = formattedSession

  const selectedFormattedDrill = useSelectedFormattedDrill()
  const activeFormattedDrill = useActiveFormattedDrill()

  const { activeStoppage } = useTimeEvents()

  // Handle drill name input //
  const [newDrillName, setNewDrillName] = useState(selectedFormattedDrill?.name)
  useEffect(() => {
    setNewDrillName(selectedFormattedDrill?.name)
  }, [selectedFormattedDrill])
  // ======================== //

  const handleStopDrill = () => {
    dispatch(stopDrill(selectedFormattedDrill?.id))
    if (activeStoppage) {
      dispatch(endTimeEvent(activeStoppage.id, { ...activeStoppage }))
    }
  }

  if (formattedSession.live && drillCount === 0) {
    return <div className={styles.noDrillsContainer}>Add A Drill</div>
  } else {
    return (
      <div className={styles.drillsControlsContainer}>
        <div className={styles.controlsMessageContainer}>
          {/* Drill name input */}
          {selectedFormattedDrill ? (
            <BasicSelect
              label={
                !selectedFormattedDrill?.id
                  ? 'No Drill Selected'
                  : 'Edit Drill Name'
              }
              variant='standard'
              selected={newDrillName}
              onChange={(value) => setNewDrillName(value)}
              labelShrink={true}
              size={'small'}
              onBlur={() => {
                if (selectedFormattedDrill) {
                  dispatch(
                    updateExistingDrill({
                      ...selectedFormattedDrill.rawData,
                      name: newDrillName,
                      sessionId: formattedSession.id
                    })
                  )
                }
              }}
              disabled={!live}
            />
          ) : (
            <div style={{ textAlign: 'center' }}>No Drill Selected</div>
          )}

          {/* Drill finished */}
          {selectedFormattedDrill?.isFinished && (
            <div className={styles.drillIsRunningMessage}>Drill Finished</div>
          )}

          {/* Stop button */}
          {selectedFormattedDrill?.isActive && (
            <Button
              className='btn--border'
              handleClick={handleStopDrill}
              style={{
                backgroundColor: '#ff0000',
                width: '100%',
                marginTop: '5px'
              }}
            >
              Stop Drill
            </Button>
          )}

          {/* Start button */}
          {live &&
            selectedFormattedDrill?.isPending &&
            (activeFormattedDrill ? (
              <div className={styles.drillIsRunningMessage}>
                Stop active drill {' ('}
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => dispatch(selectDrill(activeFormattedDrill.id))}
                >
                  {activeFormattedDrill.name}
                </span>
                {') '}
                before starting another
              </div>
            ) : (
              <Button
                className='btn--border'
                handleClick={() =>
                  dispatch(startDrill(selectedFormattedDrill.id))
                }
                style={{
                  backgroundColor: '#00ff00',
                  width: '100%',
                  marginTop: '5px'
                }}
                disabled={!!activeFormattedDrill}
              >
                Start Drill
              </Button>
            ))}
        </div>
      </div>
    )
  }
}
